import React from 'react';
import {
  Formik,
  Field,
} from 'formik';

import {
  Flex,
} from 'web-styled';
import {
  Modal,
  Button,
  TextField,
  ThreeFolders,
} from 'web-components';

type Props = {
  isOpen: boolean;
  initialName: string;
  folders: any[];
  onSubmit: { (data: any, actions: any): void };
  onRequestClose: { (): void };
};

const AddExercise = ({
  isOpen,
  initialName,
  folders,
  onSubmit,
  onRequestClose,
}: Props) => (
  <Modal
    title="Add exercise"
    isOpen={isOpen}
    onRequestClose={onRequestClose}
  >
    <Formik
      initialValues={{
        name: initialName || '',
        folder_id: folders[0]?.id,
      }}
      onSubmit={onSubmit}
    >
      {({
        values,
        setFieldValue,
        handleSubmit,
        isSubmitting,
      }) => (
        <Flex
          column
          as="form"
          width="100%"
          spacing={15}
          onSubmit={handleSubmit}
        >
          <Field
            autoFocus
            name="name"
            label="Enter name"
            placeholder="Type your exercise name here"
            component={TextField}
          />
          <ThreeFolders
            selectedId={values.folder_id}
            folderName="Exercises"
            onSelect={(id) => {
              setFieldValue('folder_id', id);
            }}
          />
          <Flex
            width="100%"
            justify="flex-end"
            spacing={20}
          >
            <Button
              ghost
              appearance="primary"
              type="submit"
              spacing="large"
              isLoading={isSubmitting}
              isDisabled={isSubmitting}
            >
              Save
            </Button>
          </Flex>
        </Flex>
      )}
    </Formik>
  </Modal>
);

export default AddExercise;
